export default "__VITE_ASSET__3CAossP6__"